export default "__VITE_ASSET__14bbfb24__"